var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"clickable-row",attrs:{"items":_vm.list,"headers":_vm.headers,"loading":_vm.loading,"search":_vm.search,"options":_vm.options,"server-items-length":_vm.totalLength,"footer-props":{ 'items-per-page-options': [10, 30, 50, 100] }},on:{"update:options":function($event){_vm.options=$event},"click:row":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }